import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const InvoiceDetailPage = lazy(() => import("@/pages/invoices.$id.page"));

export const Route = createFileRoute("/invoices/$id")({
  component: InvoiceDetailPage,
});
